import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { PageHeader } from "../molecules/Molecules"
import { H4 } from "@carrotfertility/carotene"
import { BodySmall } from "../atoms/Bodies"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../atoms/layouts/BodyWithRightSidebarLayout"
import { TextLink } from "../atoms/links/TextLink"

const BreadcrumbsLink = ({ children, ...props }) => (
  <Link {...props} className="dib no-underline black-50 hover-black animate-all">
    {children}
  </Link>
)

const Breadcrumbs = ({ list }) => {
  // add the "find a provider" link no matter what at the beginning
  const listOfLinks = []

  list.forEach(({ text, to }, index) => {
    if (index !== 0) {
      listOfLinks.push(
        <span key={index + "-slash"} className="black-50">
          {" "}
          /{" "}
        </span>
      )
    }
    if (index < list.length - 1) {
      listOfLinks.push(
        <BreadcrumbsLink key={index} to={to}>
          {text}
        </BreadcrumbsLink>
      )
    } else {
      listOfLinks.push(
        <span className="dib" key={index}>
          {text}
        </span>
      )
    }
  })

  return <H4 variant="dark">{listOfLinks}</H4>
}

Breadcrumbs.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string
    })
  ).isRequired
}

const LocationLink = ({ name, to }) => (
  <div className="mb2 mt0" key={name}>
    <BodySmall>
      <TextLink to={to}>{name}</TextLink>
    </BodySmall>
  </div>
)

const MultiColumnLayout = ({ children }) => (
  <div
    className="mb4"
    style={{
      columns: "8rem 3"
    }}
  >
    {children}
  </div>
)

const ProviderFinderLayout = ({ headerText, main, sideBar }) => (
  <MasterLayout header={<PageHeader title={headerText} icon="icn-providers" />}>
    <BodyWithRightSidebarLayout sidebar={sideBar}>{main}</BodyWithRightSidebarLayout>
  </MasterLayout>
)

ProviderFinderLayout.propTypes = {
  header: PropTypes.element,
  main: PropTypes.element.isRequired,
  sideBar: PropTypes.element
}

export { Breadcrumbs, LocationLink, MultiColumnLayout }

export default ProviderFinderLayout
